import { useEffect, useState } from 'react';
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { completeSignIn } from '@/lib/auth';

/**
 * OAuth callback handler at `/auth/callback`.
 *
 * The SPA lands here after the provider redirect, extracts the `code` query
 * param, and calls `completeSignIn` itself.
 */
function AuthCallback() {
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    void (async () => {
      try {
        if (typeof window === 'undefined') return;
        const url = new URL(window.location.href);
        await completeSignIn(url);
        if (cancelled) return;
        await navigate({ to: '/', replace: true });
      } catch (err) {
        if (cancelled) return;
        setError(err instanceof Error ? err.message : 'auth_callback_failed');
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center p-4">
      {error ? (
        <p className="text-sm text-destructive">サインインに失敗しました: {error}</p>
      ) : (
        <p className="text-sm text-muted-foreground">サインイン処理中…</p>
      )}
    </div>
  );
}

export const Route = createFileRoute('/auth/callback')({
  component: AuthCallback,
});
